export default __webpack_public_path__ + "static/media/ic_wcro_40.a4f43115.svg";